export enum EnumCardLayoutHeaderIcon {
  'CardLayoutInfo' = 'InfoCircle',
  'CardLayoutInfoInline' = 'InfoCircle',
  'CardLayoutPositive' = 'CheckCircle',
  'CardLayoutPositiveInline' = 'CheckCircle',
  'CardLayoutWarning' = 'ExclamationMark',
  'CardLayoutWarningInline' = 'ExclamationMark',
  'CardLayoutDanger' = 'Stop',
  'CardLayoutDangerInline' = 'Stop',
  'CardLayoutTip' = 'Tip',
  'CardLayoutTipInline' = 'Tip',
  'CardLayoutNeutral' = '',
  'CardLayoutNeutralInline' = ''
}
